import React, { useEffect, useMemo, useState } from "react";
import { useFormik } from "formik";
import { CiImageOn } from "react-icons/ci";
import editIcon from "../../assets/edit_icon.png";
import editButtonIcon from "../../assets/edit_button.svg";
import { Header } from "../../components/header/Header";
import LocationAutocomplete from "../../components/location/LocationAutocomplete";
import { getUserProfileThunk as onGetUserProfileThunk } from "../../slices/users/thunk";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";
import { signupUserThunk as onSignUpUser } from "../../slices/users/thunk";
import toast from "react-hot-toast";
import { Spinner } from "../../components/spinner/Spinner";
import { useParams } from "react-router-dom";
import { getAuthUser, getFileUrl } from "../../utils/GetAuthUser";
import { getRole } from "../../utils/GetRole";



const AdminProfile = () => {
  
  const [preview, setPreview] = useState(null);


  const [isEdit, setIsEdit] = useState(false);
  const [isShowLoader, setIsShowLoader] = useState(false);
  const [isProfileCreated, setIsProfileCreated] = useState(false);


  const { userId } = useParams();
  const dispatch = useDispatch();
  const fileUrl = getFileUrl();
  const currentRole = getRole();
  const authUser = getAuthUser();

  const selectUserState = (state) => state.user;
  const userSelector = createSelector(selectUserState, (user) => ({
    isLoading: user.isLoading,
    userProfileData: user.userProfileData,
    isSuccess: user.isSuccess,
  }));

  const { isLoading, userProfileData, isSuccess } = useSelector(userSelector);
  const isProfileLoading =
    isLoading ||
    !userProfileData ||
    (Array.isArray(userProfileData) && userProfileData.length === 0);

  const [initValues, setInitValues] = useState({
    name: "",
    email: "",
    location: "",
    locationLat: "",
    locationLang: "",
    artist_type: "",
    image: null,
  });

    const isOwnProfile = useMemo(() => {
  if (!userProfileData) return false;
  return authUser?.user?.id === userProfileData?.withOutEncryptId;
}, [authUser, userProfileData]);


   const canEdit =(currentRole === "admin"  && isOwnProfile);



  useEffect(() => {
    dispatch(onGetUserProfileThunk({ userId }));
  }, [dispatch, userId]);

  useEffect(() => {
    if (userProfileData) {

      setInitValues({

        id: userProfileData.id || null,
        withOutEncryptId: userProfileData.withOutEncryptId || null,
        image: userProfileData.image || null,
        name: userProfileData.name || "",
        email: userProfileData.email || "",
        location: userProfileData.location || "",
        locationLat: userProfileData.lat || "",
        locationLang: userProfileData.lang || "",
    
      });
    }
  }, [userProfileData]);

  const formik = useFormik({
    initialValues: initValues,
    enableReinitialize: true,
    onSubmit: (values) => {

      const formData = new FormData();
      formData.append("id", values.id);
      formData.append("name", values.name);
      formData.append("email", values.email);
      formData.append("location_name", values.location);
      formData.append("location_lat", values.locationLat);
      formData.append("location_lang", values.locationLang);
      formData.append("user_type",3);
      if (values.image) formData.append("image", values.image);
      dispatch(onSignUpUser(formData));

    },
  });

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      formik.setFieldValue("image", file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const changeEditStae = () => setIsEdit(true);
  const handleSave = () => formik.handleSubmit();

  useEffect(() => setIsShowLoader(isLoading), [isLoading]);

  useEffect(() => {
    if (isSuccess) setIsProfileCreated(true);
  }, [isSuccess]);

  useEffect(() => {
    if (isProfileCreated) {
      setIsShowLoader(false);
      setIsEdit(false);
      toast.success("Record updated successfully");
      setIsProfileCreated(false);
    }
  }, [isProfileCreated]);




  if (isProfileLoading) {
    return (
      <div className="w-full animate-pulse p-10">
        <div className="w-48 h-6 bg-gray-200 rounded" />
        <div className="w-64 h-4 bg-gray-200 rounded mt-2" />
      </div>
    );
  }


  return (
    <>
      <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color ">
        <Header title={"Profile Details"} showBack={true} />
      </header>

      <div className="w-full mx-auto mt-4">
        <form className="w-full">
          {/* Profile Picture */}
          <div className="w-full mt-4">
            <h2 className="text-black font-bold font-grotesk text-2xl">
              Profile Picture
            </h2>
            <p className="font-bold text-xs font-grotesk text-[#848484] mt-1">
              Change your profile picture from here
            </p>
          </div>

          <div className="w-full flex flex-col xs:flex-row items-center justify-between border border-border_color rounded-[14px] mt-5 p-3 sm:py-5 sm:px-[26px] gap-10">
            <div className="w-[128px] h-[128px] border border-secondary rounded-full p-2 flex items-center justify-center">
              <div className="relative w-[117px] h-[117px]">
                <div className="w-full h-full rounded-full bg-white overflow-hidden flex items-center justify-center">
                  {preview ? (
                    <img
                      src={preview}
                      alt="Profile"
                      className="w-full h-full object-cover object-center"
                    />
                  ) : formik.values.image ? (
                    <img
                      src={`${fileUrl}/${formik.values.image}`}
                      alt="Profile"
                      className="w-full h-full object-cover object-center"
                    />
                  ) : (
                    <span className="text-gray-500">
                      <CiImageOn className="text-8xl text-gray-300" />
                    </span>
                  )}
                </div>

                {canEdit && (
                  <>
                    <input
                      type="file"
                      id="profileUpload"
                      accept="image/png, image/jpeg, image/jpg"
                      onChange={handleImageChange}
                      className="hidden"
                    />
                    <label
                      htmlFor="profileUpload"
                      className="absolute bottom-0 right-0 rounded-full cursor-pointer"
                    >
                      <div className="w-[30px] h-[30px]">
                        <img
                          src={editIcon}
                          alt="edit"
                          className="w-full h-full object-cover"
                        />
                      </div>
                    </label>
                  </>
                )}
              </div>
            </div>

            {canEdit && (
              <div>
                {!isEdit ? (
                  <button
                    type="button"
                    className="flex items-center bg-primary text-white py-3 px-5 rounded-[10px] gap-1"
                    onClick={() => changeEditStae()}
                  >
                    <img src={editButtonIcon} alt="edit-btn" />
                    <span>Edit Profile</span>
                  </button>
                ) : (
                  <button
                    type="button"
                    className="flex items-center bg-primary text-white py-3 px-5 rounded-[10px] gap-1"
                    onClick={() => handleSave()}
                  >
                    <img src={editButtonIcon} alt="save-btn" />
                    <span>{isShowLoader ? <Spinner /> : "Save Changes"}</span>
                  </button>
                )}
              </div>
            )}
          </div>

          {/* Personal Info */}
          <div className="w-full mt-9 border border-border_color p-3 sm:py-5 sm:px-[26px] rounded-[14px]">
            <h2 className="text-black font-bold font-grotesk text-2xl mb-3">
              Personal Details
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-[10px]">
              <div className="flex flex-col">
                <label className="font-bold mb-1">Name</label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  onChange={formik.handleChange}
                  value={formik.values.name}
                  readOnly={!isEdit || !canEdit}
                  className="w-full px-3 py-[14px] border border-border_color rounded-xl outline-none"
                />
              </div>

              <div className="flex flex-col">
                <label className="font-bold mb-1">Email</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  onChange={formik.handleChange}
                  value={formik.values.email}
                  readOnly={!isEdit || !canEdit}
                  className="w-full px-3 py-[14px] border border-border_color rounded-xl outline-none"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-[10px]">
              <div className="flex flex-col">
                <label className="font-bold mb-1">Location</label>
                <LocationAutocomplete
                  value={formik.values.location}
                  onChange={(val) => formik.setFieldValue("location", val)}
                  readOnly={!isEdit || !canEdit}
                  onSelect={(place) => {
                    formik.setFieldValue("location", place.address || "");
                    formik.setFieldValue("locationLat", place.lat || "");
                    formik.setFieldValue("locationLang", place.lng || "");
                  }}
                />
              </div>
            </div>

          
          </div>
        </form>
      </div>
    </>
  );
};

export default AdminProfile;
